/** Turn any YouTube URL (watch?v=, youtu.be, shorts/, embed/) into an embed src, or null. */
export function youtubeEmbedSrc(url: string): string | null {
  const raw = url.trim();
  if (!raw) return null;
  let id: string | null = null;
  try {
    const u = new URL(raw);
    const host = u.hostname.replace(/^www\./, '');
    if (host === 'youtu.be') id = u.pathname.slice(1).split('/')[0] || null;
    else if (host.endsWith('youtube.com') || host === 'm.youtube.com') {
      if (u.pathname.startsWith('/shorts/')) id = u.pathname.split('/')[2] || null;
      else if (u.pathname === '/watch') id = u.searchParams.get('v');
      else if (u.pathname.startsWith('/embed/')) id = u.pathname.split('/')[2] || null;
    }
  } catch { return null; }
  if (!id || !/^[\w-]{6,}$/.test(id)) return null;
  return `https://www.youtube-nocookie.com/embed/${id}?rel=0&modestbranding=1`;
}

export function isYoutubeUrl(url: string): boolean {
  return youtubeEmbedSrc(url) !== null;
}
